import { render } from "./SegmentationComplexPropertyDropdown.vue?vue&type=template&id=575a34f8&scoped=true"
import script from "./SegmentationComplexPropertyDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentationComplexPropertyDropdown.vue?vue&type=script&lang=ts"

import "./SegmentationComplexPropertyDropdown.vue?vue&type=style&index=0&id=575a34f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-575a34f8"

export default script